<template>
    <div class="small text-muted">
        {{ names.length === 1 ? 'z podkladu' : 'z podkladů' }} {{ names.join(', ') }}<template v-if="quotes.length > 0">,
            <a href="#" class="link-secondary" @click.prevent="quotesShown = !quotesShown">
                {{ quotesShown ? 'skrýt citaci' : 'ukázat citaci' }}
            </a>
        </template>
        <div v-for="(quote, index) in quotesShown ? quotes : []" :key="index" class="fst-italic border-start ps-2 mt-1">
            „{{ quote.quote }}“<span v-if="quote.page !== null">, strana {{ quote.page }}</span><span
                v-if="names.length > 1">, {{ quote.sourceName }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from 'vue';
import {FoundValueOrigin} from './foundValues';

/**
 * The sources a found value comes from, in a quiet line below the value, with their quotes shown on request
 */
export default defineComponent({
    props: {
        origins: {
            type: Array as PropType<FoundValueOrigin[]>,
            required: true,
        },
        sourceNames: {
            type: Object as PropType<Record<string, string>>,
            required: true,
        },
    },
    setup(props) {
        const quotesShown = ref(false);

        const sourceName = (sourceId: string) => props.sourceNames[sourceId] ?? 'Podklad';

        const names = computed(() => [...new Set(props.origins.map(origin => sourceName(origin.sourceId)))]);

        const quotes = computed(() => props.origins
            .filter(origin => origin.quote !== null)
            .map(origin => ({quote: origin.quote, page: origin.page, sourceName: sourceName(origin.sourceId)})));

        return {quotesShown, names, quotes};
    },
});
</script>
